import { useState } from 'react';
import { adminLogin } from '../../lib/adminAuth';
import { useAdminI18n, AdminLangSelect } from '../../lib/adminI18n';
import './LoginPage.css';

// 管理画面ログイン（ID＋パスワード）
//   移行期間中（管理者アカウントが未登録の間）だけ、ID を空欄にして共有パスワードでも入れる。
//   エラー文はサーバーの文言を表示（「ID またはパスワードが正しくありません」／回数制限中の案内）。
function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const { at } = useAdminI18n();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError(null);
    try {
      await adminLogin(loginId, password);
      setPassword('');
      onLoggedIn();
    } catch (err: any) {
      setError(err instanceof TypeError ? at('login.noServer') : err?.message || at('login.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <form className="admin-login-card" onSubmit={submit}>
        <AdminLangSelect className="on-light" />
        <h1>{at('login.title')}</h1>
        <label htmlFor="admin-login-id">{at('login.id')}</label>
        <input
          id="admin-login-id"
          type="text"
          name="username"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoFocus
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
        />
        <label htmlFor="admin-password">{at('login.pw')}</label>
        <input
          id="admin-password"
          type="password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <div className="admin-login-error" role="alert">⚠ {error}</div>}
        <button type="submit" disabled={loading || !password}>
          {loading ? at('login.checking') : at('login.submit')}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
